import React, { Component } from "react";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Typography from "@material-ui/core/Typography";
// import DatePicker from "material-ui/DatePicker";
import TimePicker from "material-ui/TimePicker";
import LoadData from "../Controls/Select/DataLoadPort";
import DischargeData from "../Controls/Select/DataDischargePort";
import DataAllPort from "../Controls/Select/DataAllPort";
import EmailData from "../Controls/Select/DataCompanyEmail";
import { DateTimePicker, DatePicker } from "material-ui-pickers";
import { ModeComment } from "@material-ui/icons";
import dayjs from "dayjs"
import moment from "moment"

export const TextFieldComponent = ({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}) => (
  <div>
    <TextField
      type="text"
      disabled={props.disable}
      {...field}
      {...props}
      fullWidth
    />
    {touched[field.name] && errors[field.name] && (
      <div className="error">{errors[field.name]}</div>
    )}
  </div>
);

export const SelectCompanyEmailComponent = ({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}) => (
  <FormControl margin="normal" fullWidth>
    <TextField select className="textfield" {...field} {...props}>
      {EmailData.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.value}
        </MenuItem>
      ))}
    </TextField>
    {touched[field.name] && errors[field.name] && (
      <div className="error">{errors[field.name]}</div>
    )}
  </FormControl>
);

export const SelectLoadComponent = ({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}) => (
  <FormControl margin="normal" fullWidth>
    <TextField select className="textfield" {...field} {...props}>
      {LoadData.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.text}
        </MenuItem>
      ))}
    </TextField>
    {touched[field.name] && errors[field.name] && (
      <div className="error">{errors[field.name]}</div>
    )}
  </FormControl>
);

export const SelectDischargeComponent = ({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}) => (
  <FormControl margin="normal" fullWidth>
    <TextField
      select
      className="textfield"
      disabled={props.disable}
      {...field}
      {...props}
    >
      {DischargeData.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.text}
        </MenuItem>
      ))}
    </TextField>
    {touched[field.name] && errors[field.name] && (
      <div className="error">{errors[field.name]}</div>
    )}
  </FormControl>
);

export const SelectAllPortComponent = ({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}) => (
  <FormControl margin="normal" fullWidth>
    <TextField
      select
      className="textfield"
      disabled={props.disable}
      {...field}
      {...props}
    >
      {DataAllPort.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.text}
        </MenuItem>
      ))}
    </TextField>
    {touched[field.name] && errors[field.name] && (
      <div className="error">{errors[field.name]}</div>
    )}
  </FormControl>
);

export const DatePickerComponent = ({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors, setFieldValue }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}) => (
  <div className="datetime">
    <DatePicker
      clearable
      format={"dd MMM yyyy"}
      disabled={props.disable}
      label={props.label}
      onChange={props.onChange}
      value={
        field.value == null || field.value == "" || field.value == " "
          ? null
          : new Date(field.value)
      }
    // {...field}
    // {...props}
    />
    {touched[field.name] && errors[field.name] && (
      <div className="error">{errors[field.name]}</div>
    )}
  </div>
);

export const DatePickerComponentNew = ({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors, setFieldValue }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}) => (
  <div className="picker">
    <DateTimePicker
      // keyboard
      clearable
      // shouldDisableDate={props.disable}
      ampm={false}
      disabled={props.disable}
      label={props.label}
      disableFuture={props.disableFuture}
      // format={'yyyy-MM-dd hh:mm'}
      format={"dd MMM yyyy HH:mm"}
      onChange={props.onChange}
      value={
        field.value == null || field.value == "" || field.value == " "
          ? null
          : new Date(field.value)
      }
      disableOpenOnEnter
    />
    {touched[field.name] && errors[field.name] && (
      <div className="error">{errors[field.name]}</div>
    )}
  </div>
);

export const DatePickerComponentAutoGR = ({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors, setFieldValue }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}) => (
  <div className="picker">
    <DateTimePicker
      renderInput={(params) => <TextField {...params} />}
      // keyboard
      clearable
      // shouldDisableDate={props.disable}
      disabled={props.disabled}
      label={props.label}
      disableFuture={props.disableFuture}
      // format={'yyyy-MM-dd hh:mm'}
      format={"dd MMM yyyy HH:mm"}
      onChange={props.onChange}
      minDate={props.minTime}
      value={
        field.value === null || field.value === "" || field.value === " " || field.value === undefined
          ? null
          : new Date(field.value)
      }
      disableOpenOnEnter
    />
    {touched[field.name] && errors[field.name] && (
      <div className="error">{errors[field.name]}</div>
    )}
  </div>
);

export const TimePickerComponent = ({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}) => (
  <div className="datetime">
    <TimePicker
      minutesStep={1}
      fullWidth
      floatingLabelText={props.label}
      className="textfield"
      {...field}
      {...props}
      inputProps={{
        step: 100, // 1 min
      }}
    />
    {touched[field.name] && errors[field.name] && (
      <div className="error">{errors[field.name]}</div>
    )}
  </div>
);
export const CheckboxComponent = ({
  field,
  form: { touched, errors },
  ...props
}) => {
  return (
    <div>
      <FormControlLabel
        control={<Checkbox checked={field.value} color="primary" {...field} />}
        disabled={props.disable}
        label={props.label}
      />
      {touched[field.name] && errors[field.name] && (
        <div className="error">{errors[field.name]}</div>
      )}
    </div>
  );
};

export const SelectComponent = ({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}) => (
  <div>
    <TextField select fullWidth disabled={props.disable} {...field} {...props}>
      {props.data.map((option) => (
        <MenuItem key={unescape(option.value)} value={unescape(option.value)}>
          {unescape(option.text)}
        </MenuItem>
      ))}
    </TextField>
    {touched[field.name] && errors[field.name] && (
      <div className="error">{errors[field.name]}</div>
    )}
  </div>
);

export const SelectComponentOldKey = ({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}) => (
  <div>
    <TextField select fullWidth disabled={props.disable} {...field} {...props}>
      {props.data.map((option) => (
        <MenuItem key={unescape(option.oldKey)} value={unescape(option.oldKey)}>
          {unescape(option.text)}
        </MenuItem>
      ))}
    </TextField>
    {touched[field.name] && errors[field.name] && (
      <div className="error">{errors[field.name]}</div>
    )}
  </div>
);



// WEBPACK FOOTER //
// ./src/components/FormComponent.js